import $ from 'jquery';

export let cr_state = 0;
export let open_menu_state = 0;

/**
 * Open the select option dropdown
 */
export const openSelectOptions = {
    openSelectOption: function(j_state, selector) {
        if (cr_state == 0) {
            $('.' + selector).fadeIn();
            $('#' + selector).removeClass('animate-fadeOutTop');
            $('#' + selector).addClass('animate-fadeInTop');
        } else {
            $('#' + selector).removeClass('animate-fadeInTop');
            $('#' + selector).addClass('animate-fadeOutTop');
            $('.' + selector).fadeOut();
        }

        if (j_state == 0) {
            j_state = 1;
        } else {
            j_state = 0;
        }

        cr_state = j_state;

        return cr_state;
    }
}

/**
 * Choose an option in select option
 */
export const selectOption = {
    chooseOption: function(selected_id, selector) {

        $('#' + selector).removeClass('animate-fadeInTop');
        $('#' + selector).addClass('animate-fadeOutTop');
        $('.' + selector).fadeOut();

        cr_state = 0;

        return cr_state;
    }
}



//HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
// $(document).bind('click', function(e) {
//     let $clicked = $(e.target);

//     if (! $clicked.parents().hasClass("select-box")) {
//         // $('.select-opts').removeClass('animate-fadeInRight');
//         // $('.select-opts').addClass('animate-fadeOutRight');
//         // $('.select-opts').fadeOut();

//         this.openSelectOptions.openSelectOption(1, 'select-box');

//     }
// });


/**
 * Open option dropdown
//  */
// async openOption(v) {

//         if (v == 0) {
//             v = 1;
//         } else {
//             v = 0;
//         }

//         if (this.v == 0) {
//             $(".option-box").fadeIn();
//             $(".option-box").removeClass("animate-fadeOutRight");
//             $(".option-box").addClass("animate-fadeInRight");
//         } else {
//             $(".option-box").removeClass("animate-fadeInRight");
//             $(".option-box").addClass("animate-fadeOutRight");
//             $(".option-box").fadeOut();
//         }
//         this.v = v;
//     },

//     async closeDropOption() {
//         $(".option-box").removeClass("animate-fadeInRight");
//         $(".option-box").addClass("animate-fadeOutRight");
//         $(".option-box").fadeOut();

//         this.v = 0;
//     },